import { ponudba } from "@/mocks/ponudba";
import { ponudbaKategorije } from "@/mocks/ponudbaMeni";
import ImageSlot from "@/components/base/ImageSlot";
import MenuAccordion from "@/pages/home/components/MenuAccordion";

export default function Offer() {
  return (
    <section id="ponudba" className="scroll-mt-24 bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="section-shell">
        <div className="reveal flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-4">
              <span className="font-label text-[10px] font-semibold tracking-[0.2em] text-accent-700">
                02
              </span>
              <span className="rule-line" />
              <span className="eyebrow text-secondary-600">Naša ponudba</span>
            </div>
            <h2 className="headline mt-5 max-w-[560px] text-[31px] text-foreground-950 sm:mt-6 sm:text-[39px] lg:text-[48px]">
              Izberite svoj
              <span className="block italic text-secondary-600">trenutek dneva.</span>
            </h2>
          </div>
          <div className="md:max-w-[340px] md:text-right">
            <p className="text-[14px] leading-relaxed text-foreground-600">
              Od prve jutranje kave do sproščenega večera — ponudba je sestavljena
              tako, da se vedno najde nekaj za vaš trenutek.
            </p>
            <p className="mt-4 flex items-center gap-2 font-label text-[9px] uppercase tracking-[0.2em] text-foreground-400 md:justify-end">
              <span className="h-px w-6 bg-accent-500/60" />
              11 kategorij · celotna ponudba
            </p>
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:mt-14 lg:grid-cols-4">
          {ponudba.map((item, index) => (
            <article
              key={item.id}
              className="reveal card-lift group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-accent-400 hover:bg-background-100/40"
              style={{ transitionDelay: `${index * 110}ms` }}
            >
              <div className="relative h-[186px] w-full overflow-hidden sm:h-[220px]">
                {item.slika ? (
                  <img
                    src={item.slika}
                    alt={item.alt}
                    title={`${item.naslov} – Bar Stanka Ptuj`}
                    className="h-full w-full object-cover object-center transition-transform duration-[1200ms] ease-smooth group-hover:scale-[1.07]"
                  />
                ) : (
                  <ImageSlot
                    tone="light"
                    icon="ri-image-add-line"
                    label="Prostor za fotografijo"
                  />
                )}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/25 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <span className="absolute left-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 font-label text-[10px] font-bold tracking-[0.1em] text-primary-900 backdrop-blur-sm">
                  {item.oznaka}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 sm:p-5 md:p-6">
                <h3 className="font-heading text-[20px] leading-tight text-foreground-950 sm:text-[22px]">
                  {item.naslov}
                </h3>
                <p className="mt-3 flex-1 text-[13.5px] leading-relaxed text-foreground-600">
                  {item.opis}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-[9px] uppercase tracking-[0.18em] text-foreground-400">
                    Bar Stanka
                  </span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border border-secondary-300 text-secondary-600 transition-all duration-500 group-hover:border-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="reveal mt-9 flex flex-wrap items-center gap-4 rounded-lg border border-background-200 bg-background-100 px-5 py-4 sm:px-7">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-900 text-accent-300">
            <i className="ri-cup-line text-base" />
          </span>
          <p className="text-[13px] leading-relaxed text-foreground-700">
            Vsak trenutek dneva ima svoj okus — izbira je prepuščena vam.
          </p>
        </div>

        <MenuAccordion kategorije={ponudbaKategorije} />
      </div>
    </section>
  );
}